<style scoped>
  .hostContainer.box {
    margin-bottom: 0.25rem;
    margin-top: 0.25rem;
  }
  .franchiseSelector {
    padding-left: 10px;
    margin-top: 10px;
    span {
      margin-right: 10px;
    }
    div {
      min-width: 275px;
      margin-top: -2px;
    }
  }
  .v-select.single.open .selected-tag {
    position: relative !important;
  }
</style>
<template xmlns="http://www.w3.org/1999/html">
  <div>
    <div
      v-if="!receivedFranchises"
      class="spinner-loader"
    >
      <sync-loader />
      Loading...
    </div>
    <div v-if="receivedFranchises">
      <div class="columns">
        <div class="column is-12">
          <div class="div-table">
            <div class="columns is-gapless">
              <div class="column is-12 card-header has-text-centered button-tools">
                <strong>Point Races</strong>
                <div
                  class="button is-info is-pulled-right"
                  @click="addNew()"
                >
                  New Point Race
                  <div style="border-radius: 15px;height: 16px;background-color: white;">
                    <span
                      class="fas fa-plus-circle addhost"
                      style="font-weight:900; color: limegreen;position: relative;top: -4px;"
                    />
                  </div>
                </div>
                <toggle-button
                  v-model="searchActive"
                  :width="80"
                  :height="30"
                  :speed="480"
                  :sync="true"
                  :labels="{checked: 'Active', unchecked: 'Inactive'}"
                  :color="{checked: '#7DCE94', unchecked: '#CCC'}"
                  @change="getAvailableLists()"
                />
                <div />
              </div>
            </div>
            <div class="column is-12">
              <div class="columns">
                <div class="column is-2">
                  <label class="label">Franchise:</label>
                </div>
                <div class="column is-4">
                  <v-select
                    v-model="selectedFranchise"
                    :options="franchises"
                    label="name"
                  />
                </div>
              </div>
              <div v-if="lists.length">
                <div
                  v-for="list in lists"
                  class="box p-1 mt-4 is-radiusless hostContainer"
                >
                  <div class="border-bottom is-flex flex-row space-between relative align-center p-1">
                    <div class="is-flex flex-row align-center">
                      <div class="ml-4">
                        <router-link
                          :to="`/admin/lists/edit/${list.id}`"
                          class="mr-1 is-size-7-touch"
                        >
                          {{ list.tablabel }}
                          <br>
                          <b><i>{{ list.region | readableRegion }}</i></b>
                        </router-link>
                      </div>
                    </div>
                    <div>
                      <a
                        data-tooltip="Edit Point Race"
                        class="btn-icon tooltip"
                        @click="editList(list.id)"
                      >
                        <i class="far fa-edit" />
                      </a>
                      <a
                        data-tooltip="Delete Point Race"
                        class="btn-icon tooltip"
                        @click="deleteList(list.id)"
                      >
                        <i class="far fa-ban has-text-danger" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .list-name {
    margin-left: 25px;
  }
  .points-list-container {
    background-color: #909090;
    padding:15px;
  }
  .list {
    cursor:pointer;
    background-color: #F8F8F8;
    margin-top: 0px;
    padding: 10px;
    color: #454545;
    margin-bottom: 8px;
    font-weight: bold;
    border-radius: 13px;
  }
</style>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import PrettyCheckbox from 'pretty-checkbox-vue'
  import vSelect from 'vue-select'
  export default {
    name: 'ToolsListLists',
    filters: {
      readableRegion: function (r) {
        return r.toString() === '0' ? 'All Regions' : 'Region: ' + r
      }
    },
    components: {
      'v-select': vSelect,
    },
    props: ['user', 'token'],
    data () {
      return {
        lists: [],
        config: {
          key: 'GPD2tA17B2A2C1A1B1sqyI-7cB-22C-16seD2zuvc1A6B5A4D3A3B2B2G3A4A3==',
          imageUploadParam: 'file',
          imageUploadURL: 'https://rest.ahlpoker.com/image/upload',
          imageUploadParams: {
            id: 'my_editor',
            token: ''
          },
          imageUploadMethod: 'POST',
          imageMaxSize: 5 * 1024 * 1024,
          imageAllowedTypes: ['jpeg', 'jpg', 'png'],
            imageManagerLoadMethod: 'GET',
          imageManagerLoadURL: 'https://rest.ahlpoker.com/image/getlist',
          imageManagerDeleteURL: 'https://rest.ahlpoker.com/image/delete',
          events: {
            'froalaEditor.image.loaded': (e, editor, $img) => {
              this['_data'].images.push($img[0].src)
            },
            'froalaEditor.image.removed': (e, editor, $img) => {
              let index = this['_data'].images.find((image) => {
                return image === $img[0].src
              })
              this['_data'].images.splice(index, 1)
            }
          }
        },
        searchActive: true,
        franchises: [],
        selectedFranchise: null,
        receivedFranchises: false,
      }
    },
    computed: {
    },
    watch: {
      selectedFranchise: function() {
        this.getAvailableLists()
      },
    },
    created () {
      if (!this.user || !this.user.isHost) this.$router.push({name: 'FourZeroFour'})
    },
    mounted() {
      this.getFranchises()
    },
    methods: {
      getFranchises() {
        let url = `admin/lists/getfranchises`
        let data = {
          token: this.token
        }
        this.$axios({
          method: 'POST',
          url,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data
        })
          .then((res) => {
            console.log(res)
            this.franchises = res.data
            this.selectedFranchise = res.data[0]
            this.getAvailableLists()
            this.receivedFranchises = true
          })
          .catch((error) => {
            console.log(error)
          })
      },
      getAvailableLists() {
        this.$axios({
          method: 'POST',
          url: '/admin/lists/getlists/' + this.selectedFranchise.id,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token,
          }
        })
          .then((res) => {
            for (var i = 0; i < res.data.length; i++) {
              res.data[i].checked = false
            }
            this.lists = res.data
          })
          .catch((error) => {
            console.log(error)
          })
      },
      deleteList(listId) {
        var self = this
        this.$dialog.confirm('Are you sure you wish to delete this point race?')
          .then(function () {
            self.doDeleteList(listId)
          })
          .catch(function () {
            console.log('Clicked on cancel')
          })
      },
      doDeleteList(listId) {
        let deleteUrl = `admin/lists/deletetab`
        let data = {
          token: this.token,
          id: listId
        }
        this.$axios({
          method: 'POST',
          url: deleteUrl,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data
        })
          .then((res) => {
            this.$emit('message', {
              showDialog: true,
              error: res.data.error,
              message: res.data.message
            })
            this.getAvailableLists()
          })
          .catch((error) => {
            console.log(error.response)
          })
      },
      addNew() {
        this.$router.push({path: '/admin/lists/add'})
      },
      editList(id) {
        this.$router.push({path: '/admin/lists/edit/' + id})
      }
    }
  }
</script>
